import * as React from "react"

export function BookingSidebar({ children }: { children: React.ReactNode }) {
    const sidebarRef = React.useRef<HTMLElement>(null)
    const [trackHeight, setTrackHeight] = React.useState(0)

    React.useLayoutEffect(() => {
        const sidebar = sidebarRef.current
        if (!sidebar) return
        const update = () => {
            if (!window.matchMedia("(min-width: 980px)").matches) {
                setTrackHeight(0)
                return
            }
            const top = parseFloat(getComputedStyle(sidebar).top) || 0
            const height = sidebar.getBoundingClientRect().height
            const availableHeight = Math.max(0, window.innerHeight - top - 24)
            // Give tall sidebars room to stick before the track's bottom releases them.
            // Their full height stays in page flow, so every tile can reach the viewport.
            setTrackHeight(height + Math.max(0, height - availableHeight))
        }
        update()
        const observer = new ResizeObserver(update)
        observer.observe(sidebar)
        const header = document.querySelector(".booking-header")
        if (header) observer.observe(header)
        window.addEventListener("resize", update)
        return () => {
            observer.disconnect()
            window.removeEventListener("resize", update)
        }
    }, [])

    return <div className="ah-sidebar-track" style={{ "--ah-sidebar-track-height": `${trackHeight}px` } as React.CSSProperties}>
        <aside ref={sidebarRef} className="ah-summary">{children}</aside>
    </div>
}
